// extracted by mini-css-extract-plugin
var _1 = "ys0KL custom-attribute-color";
var _2 = "LTqre";
var _3 = "BumwC";
export { _1 as "base", _2 as "hideLabel", _3 as "label" }
